import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function TaskCompletionRejectedCard({ answer }: Props) {
  return (
    <article className="rounded-lg border border-slate-300 bg-slate-50 p-4 text-sm text-slate-800">
      <div className="mb-2 flex items-center gap-2">
        <span className="rounded bg-slate-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-700">
          Not changed
        </span>
        {answer.decision_basis && (
          <span className="text-xs text-slate-600">{answer.decision_basis}</span>
        )}
      </div>
      <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
      {answer.audit_id && (
        <p className="mt-2 text-[10px] uppercase tracking-wide text-slate-500">
          audit: {String(answer.audit_id).slice(0, 8)}
        </p>
      )}
    </article>
  );
}
